import React, { FC } from 'react';
import Modal from '../../common/Modal/Modal';
import { OTPType } from '../../../hooks/mutates/useOTP';

interface Props {
  type: OTPType;
  isShow: boolean;
  onRequestClose: () => void;
  onClick: VoidFunction;
}

const ModalOTPFailed: FC<Props> = ({
  type,
  isShow,
  onRequestClose,
  onClick,
}) => {
  return (
    <Modal
      size="sm"
      isShow={isShow}
      title={
        type === `logIn`
          ? `Wallet could not be connected`
          : `Authentication failed`
      }
      onClose={onRequestClose}
      explanation={
        <>
          The verification code is not valid.
          <br />
          Please check your account and try again.
        </>
      }
      footerComponent={
        <button onClick={onClick} className="btn btn-block btn-primary btn-lg">
          OK
        </button>
      }
    />
  );
};

export default ModalOTPFailed;
